import axios from "axios";
import {
  DonorURL,
  DonationURL,
  OrganizationURL
} from "../../../../config/UrlEndPoint";
import { DONATION_URL } from "../../../Donation/_redux/donation/donationCrud";

export const URL = `${OrganizationURL}organization`;
export const URLDONATION = `${DonationURL}donation`;
export const URLCONSOLIDATION = `${DonationURL}consolidation`;

// items => filtered/sorted result
export function findOrganizations(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// get ALL organization with search
export function searchOrganizations(search) {
  return axios.post(`${URL}/search`, search);
}

//Get By ID
export function getOrganizationById(organizationId) {
  return axios.get(`${URL}`);
}

// POST => POST: Create the organization on the server
export function createOrganization(organization) {
  return axios.post(URL, organization);
}

//GET => GET ALL PARENT BY TYPE
export function getParents(id) {
  return axios.get(`${URL}/parent/${id}`);
}

//GET => GET ALL PARENT BY TYPE
export function getChilds(id) {
  return axios.get(`${URL}/child/${id}`);
}

// UPDATE => PUT: update the organization on the server
export function updateOrganization(organization) {
  return axios.put(`${URL}`, organization);
}

// UPDATE => BRANCH DONATUR
export function updateBranch(organization) {
  return axios.put(`${URL}/branch/change`, organization);
}

// GET DONATUR FROM DONATUR URL
export function getDonationList(organization) {
  return axios.post(`${URLDONATION}/donorid`, organization);
}

// add parent
export function addParent(organization) {
  return axios.post(`${URL}/parent/add`, organization);
}

// remove parent
export function deleteParent(organization) {
  return axios.delete(`${URL}/parent/delete`, { data: organization });
}

//Generate EXCEL
export function generateReportDonor(payload) {
  return axios.post(`${URL}/report`, payload);
}

//Change Password
export function changePasswordOrganization(payload) {
  return axios.post(`${URL}/change_password`, payload);
}

export function migrateDonation(payload) {
  return axios.put(`${URLDONATION}/migrate_donation`, payload);
}

export function generatePrintConsolidationDonor(payload) {
  return axios.post(`${URLCONSOLIDATION}/print_consolidation_donor`, payload, {
    responseType: "blob"
  });
}

export const updateEmailConfiguration = payload => {
  return axios.put(`${URL}/email_configuration`, payload);
};

export const orgTestEmailConfiguration = payload => {
  return axios.post(`${URL}/test_org_email_config`, payload);
};
